import { render, staticRenderFns } from "./CrearConvenio.vue?vue&type=template&id=2bc5f114"
import script from "./CrearConvenio.vue?vue&type=script&lang=js"
export * from "./CrearConvenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports